import Navbar from '../components/navbar';
import Footer from '../components/footer';
import HeroSection from '../components/heroSection';
import Experience from '../components/experience';
import Contact from '../components/contact';
import About from '../components/about';
import Projects from '../components/projects';

function LandingPage() {
    return (
        <div className="bg-base-200">
            {/* Navbar */}
            <Navbar />

            {/* Hero Section */}
            <section id="home">
                <HeroSection />
            </section>


            {/* About Section */}
            <section id="about">
                <About />
            </section>

            {/* Experience Section */}
            <section id="experience">
                <Experience />
            </section>

            {/* Projects Section */}
            <section id="projects">
                <Projects />
            </section>

            {/* Contact Section */}
            <section id="contact">
                <Contact />
            </section>

            {/* Footer */}
            <Footer />
        </div>
    );
}

export default LandingPage;
